import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) {}

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      //this.router.navigate(['/logout']);
      this.auth.logout();
      return false;
    }
    //AVOID MULTILOGIN - https://trello.com/c/Cq3C5yWy/708-avoid-multilogin-kcms - Start
    sessionStorage.setItem('isAnyLoginSession','Yes');
    sessionStorage.setItem('userEmail', localStorage.getItem('userEmail'));
    //AVOID MULTILOGIN - End
    return true;
  }

}
